import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-38a869f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav" }
const _hoisted_2 = { class: "nav-list" }
const _hoisted_3 = ["onClick", "onKeypress"]

import { ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NavBar',
  props: {
    navItems: {},
    selectedItem: {},
    onSelectItem: { type: Function }
  },
  setup(__props: any) {

const props = __props;

const selectedItem = ref(props.selectedItem);

const selectItem = (item: string) => {
  selectedItem.value = item;
  props.onSelectItem(item);
};

watch(
  () => props.selectedItem,
  (newValue) => {
    selectedItem.value = newValue;
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navItems, (item) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item,
          class: _normalizeClass(['nav-item', { active: item === selectedItem.value }]),
          onClick: ($event: any) => (selectItem(item)),
          onKeypress: ($event: any) => (selectItem(item)),
          tabindex: "0"
        }, _toDisplayString(item), 43, _hoisted_3))
      }), 128))
    ])
  ]))
}
}

})